import RequestStatus from "../model/RequestStatus";
import {GetProductPageDataResponse} from "../model/ProductMatch";
import {
    GetMerchantProductDataQueryComplete,
    MERCHANT_PRODUCT_DATA_QUERY_FAILED,
    MERCHANT_PRODUCT_DATA_QUERY_START,
    MERCHANT_PRODUCT_DATA_QUERY_SUCCESS
} from "../actions/MerchantProductSearchAction";
import {PRODUCT_DATA_QUERY_START} from "src/actions/ProductSearchAction";

const initialState: GetProductPageDataResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    productData: null,
};

export default (
    state: GetProductPageDataResponse = initialState,
    action: GetMerchantProductDataQueryComplete
): GetProductPageDataResponse => {
    switch (action.type) {
        case PRODUCT_DATA_QUERY_START:// clear product result when start new search
            return initialState;
        case MERCHANT_PRODUCT_DATA_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                productData: null,
            };
        case MERCHANT_PRODUCT_DATA_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                productData: action.productData,
            };
        case MERCHANT_PRODUCT_DATA_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                productData: null,
            };
        default:
            return state;
    }
};

